import { AxiosInstance } from 'axios'

export interface Crm {
  crm: string
  state: string
}

export interface ValidateCpfCrmInput {
  cpf: string
  crm: Crm[]
}

export interface ValidateCpfOutput {
  valid: boolean
  message?: string
}

export function validationsEndpoints(apiClient: AxiosInstance) {
  return {
    async validateCpfCrm({ cpf, crm }: ValidateCpfCrmInput): Promise<ValidateCpfOutput> {
      return apiClient.post('validate-cpf-crm', { cpf, crm })
    },
  }
}
